// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

/**
 * Komponenta pro manipulaci s tlačítkem Zpět v detailu produktu
 *
 */

const fragments = {
    LINK: '[data-fragment="GoToCategory.link"]'
};
export default class GoToCategory extends WebComponent {

    didMount() {
        this.link = this.element.querySelector(fragments.LINK);

        if (document.referrer.split('/')[2] === window.location.host && window.history.length > 1) {
            this.link.addEventListener('click', function(e) {
                e.preventDefault();
                window.history.back();
            });
        }
    }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/GoToCategory.js